export default "__VITE_ASSET__Cak17HtX__"